import { Component, Inject } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";

@Component({
  selector: "app-caller-actions",
  templateUrl: "./caller-actions.component.html",
  styleUrls: ["./caller-actions.component.css"],
})
export class CallerActionsComponent {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<CallerActionsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}
  callCustomer() {
    window.location.href = `tel:${this.data.phone}`;
  }
  whatsapp() {
    const url = `https://wa.me/+91${this.data.phone}`;
    window.open(url, "_blank");
  }
  close() {
    this.bottomSheetRef.dismiss();
  }
}
